exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-content {\r\n    border: 1px solid #ddd;\r\n    padding: 20px; \r\n}\r\n\r\n.error {\r\n    color:red;\r\n}\r\n\r\n.success {\r\n    color: green;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/binance-api/binance-api.component.css
// module id = ../../../../../src/app/_components/binance-api/binance-api.component.css
// module chunks = main